
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 25 25","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6.215 1.676C8.101.559 10.195 0 12.5 0c2.235 0 4.33.559 6.285 1.676s3.422 2.654 4.539 4.54C24.441 8.1 25 10.195 25 12.5c0 2.305-.559 4.33-1.676 6.285a12.847 12.847 0 01-4.54 4.539C16.9 24.441 14.805 25 12.5 25c-2.235 0-4.33-.559-6.285-1.676a12.847 12.847 0 01-4.539-4.54C.559 16.9 0 14.805 0 12.5c0-2.305.559-4.33 1.676-6.285a12.848 12.848 0 014.54-4.539zm12.43 4.679C16.97 4.679 14.875 3.84 12.5 3.84c-2.374 0-4.4.838-6.145 2.514C4.679 8.03 3.84 10.125 3.84 12.5c0 2.374.838 4.4 2.514 6.145 1.676 1.676 3.77 2.514 6.145 2.514 2.374 0 4.4-.838 6.145-2.514 1.676-1.676 2.514-3.77 2.514-6.145 0-2.374-.838-4.47-2.514-6.145zm-1.047 3.282l-2.863 2.793 2.863 2.793-2.305 2.305-2.793-2.793-2.793 2.793-2.305-2.304 2.863-2.794-2.863-2.793 2.305-2.305 2.793 2.794 2.793-2.794 2.305 2.305z"}})])
          )
        }
      }
    